import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import ListaPrecioTipo from './ListaPrecioTipo.js';
import ACCESS from '../../../ACCESS.js';

class ListaPrecioTipos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'lista-precio-tipo/filter', deleteUrl: 'lista-precio-tipo/delete', deleteField: 'lpt_nombre', modUrl: '/Catalogo/ListaPrecioTipo' },
      TableOp.Table('Tipos de Lista de Precios', [
        { label: 'Nombre del Tipo de Lista', id: 'lpt_nombre' },
      ], []))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <ListaPrecioTipo  onSave={() => {this.table()}}></ListaPrecioTipo>
          }
          {
             
          <this.TableRender  />
          }
        </div>
      </div>
    )
  }
}

export default withRouter(ListaPrecioTipos)